import React, { useRef, useState } from 'react';

import { ClickAwayListener } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { OKRMenuOptions } from 'screens/analytics/commonComponents';
import styled from 'styled-components';
import { FlexContainer, StyledButton, StyledIconButton, VerticallyAlignedFlexContainer } from 'styles/common';

import { PlusIcon3, StyledIcon } from 'constants/icons';
import { sendClickedOnCreateKRevent, sendClickedOnCreateObjectiveEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';

const AddNewObjectiveOrGoalRow = ({
  setIsOpenCreateObjectivePanel = () => {},
  setIsOpenCreateGoalPanel = () => {},
  isTeamHubView = false,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const anchorRef = useRef();

  return (
    <FlexContainer>
      <ClickAwayListener onClickAway={() => setMenuIsOpen(false)}>
        <StyledButton
          variant="outlined"
          borderColor="primary"
          onClick={() => setMenuIsOpen((prev) => !prev)}
          customColor="white"
          style={{
            marginBottom: '1rem',
            marginTop: '1rem',
            marginLeft: 'auto',
            height: '2.5rem',
          }}
          ref={anchorRef}
        >
          <VerticallyAlignedFlexContainer>
            <ColoredIconButton style={{ marginRight: '0.5rem' }}>
              <PlusIcon3 size="fixed10px" color="blue" />
            </ColoredIconButton>
            <Typography13 customColor="primary">Add New</Typography13>
            <StyledIcon size="header" color="primary">
              <ArrowDropDownIcon />
            </StyledIcon>
          </VerticallyAlignedFlexContainer>
        </StyledButton>
      </ClickAwayListener>
      <OKRMenuOptions
        addKR={() => {
          sendClickedOnCreateKRevent({
            eventProperties: {
              source: 'Insights Page',
            },
          });
          setIsOpenCreateGoalPanel(true);
        }}
        addObjective={() => {
          sendClickedOnCreateObjectiveEvent({
            eventProperties: {
              source: isTeamHubView ? 'Team Page' : 'Insights Page',
            },
          });
          setIsOpenCreateObjectivePanel(true);
        }}
        anchorEl={anchorRef}
        isOpen={menuIsOpen}
        setIsOpen={setMenuIsOpen}
      />
    </FlexContainer>
  );
};

const ColoredIconButton = styled(StyledIconButton)`
  position: relative;
  background: ${theme.palette.icons.white};
  border: 1px solid ${theme.palette.icons.blue};
  width: 24px;
  height: 24px;
`;

export default AddNewObjectiveOrGoalRow;
